import { Component, Prop, Vue } from 'vue-property-decorator'
import ConfigurationRelationships
    from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationPersonnelResponse } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel/configuration-personnel.dto'
import {
    ConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentFormState,
    initialConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentFormState
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/components/modal-department-type-assignment-form/configuration-automation-personnel-entities-association-modal-department-type-assignment-form.model'
import { CommonDepartmentTypeResponse } from '@/api/services/common/department-type/common-department-type.dto'
import { commonDepartmentTypeService } from '@/api/services/common/department-type/common-department-type.service'
import {
    ConfigurationPersonnelDepartmentTypeAssignmentCreateRequest,
    ConfigurationPersonnelDepartmentTypeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-department-type-assignment/configuration-personnel-department-type-assignment.dto'
import { configurationPersonnelDepartmentTypeAssignmentService } from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-department-type-assignment/configuration-personnel-department-type-assignment.service'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly personnel!: ConfigurationPersonnelResponse

    state: ConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentFormState
    constructor() {
        super()
        this.state = initialConfigurationAutomationPersonnelEntitiesAssociationModalDepartmentTypeAssignmentFormState()
    }

    private async _loadDepartmentTypes(): Promise<void> {
        this.state.departmentTypes = await this._getDepartmentTypes()
    }

    private async _loadPersonnelDepartmentTypeAssignments(): Promise<void> {
        this.state.personnelDepartmentTypeAssignments = await this._getPersonnelDepartmentTypeAssignments()
    }

    async mounted() {
        await this._loadDepartmentTypes()
        await this._loadPersonnelDepartmentTypeAssignments()
    }

    /// SERVICES CALLS ///

    private async _getDepartmentTypes(): Promise<CommonDepartmentTypeResponse[]> {
        const response = await this.$_toCallUnique(commonDepartmentTypeService.getDepartmentTypesActive())
        if (response) {
            return response
        }
        return []
    }

    private async _getPersonnelDepartmentTypeAssignments(): Promise<ConfigurationPersonnelDepartmentTypeAssignmentResponse[]> {
        const filterModel: CommonFilterModel = {
            'personnel.id': GridUtils.getNumberFilterModel('equals', this.personnel.id)
        }
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationPersonnelDepartmentTypeAssignmentService.paginator(filterModel, params, this.state.laboratoryId))
        if (response) {
            return response.content
        }
        return []
    }

    private async _createPersonnelDepartmentTypeAssignment(createRequest: ConfigurationPersonnelDepartmentTypeAssignmentCreateRequest): Promise<ConfigurationPersonnelDepartmentTypeAssignmentResponse | null> {
        const response = await this.$_toCallUnique(configurationPersonnelDepartmentTypeAssignmentService.create(this.state.laboratoryId, createRequest))
        if (response) {
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.created'))
            return response
        }
        return null
    }

    private async _deletePersonnelDepartmentTypeAssignment(personnelDepartmentTypeAssignmentId: number): Promise<void> {
        if (personnelDepartmentTypeAssignmentId) {
            await this.$_toCallUnique(configurationPersonnelDepartmentTypeAssignmentService.delete(personnelDepartmentTypeAssignmentId, this.state.laboratoryId))
            this.$_showToastSuccess(this.$tc('configuration.toastMessages.deleted'))
        }
    }

    /// FORM OPERATIONS ///

    async createOperation(departmentType: CommonDepartmentTypeResponse): Promise<void> {
        if (departmentType) {
            const createRequest: ConfigurationPersonnelDepartmentTypeAssignmentCreateRequest = {
                personnelId: this.personnel.id,
                departmentTypeId: departmentType.id
            }
            if (await this._createPersonnelDepartmentTypeAssignment(createRequest)) {
                await this._loadPersonnelDepartmentTypeAssignments()
            }
        }
    }

    async deleteOperation(personnelDepartmentTypeAssignment: ConfigurationPersonnelDepartmentTypeAssignmentResponse): Promise<void> {
        if (personnelDepartmentTypeAssignment) {
            await this._deletePersonnelDepartmentTypeAssignment(personnelDepartmentTypeAssignment.id)
            await this._loadPersonnelDepartmentTypeAssignments()
        }
    }
}
